import React, { useMemo, useState } from 'react'
import styles from "./Table.module.scss";
import { takeObjects } from '../../utils/takeObects'
import NoData from '../../assets/NoData/NoData';
import Popup from './Popup';
const Table = ({
    data,
    setReport,
    year,
    month,
    getAchievDetails,
    updateAchieveDetails,
    resetAchieveDetails,
    achieveDetails,
    getAchieveFile,
    schema,
    group,
    facultLabel,
    groupLabel,
    state
}) => {
    const [currentCell, setCurrentCell] = useState('');
    const [valueData, setValueData] = useState('');
    const [all, setAll] = useState('');
    const [nesting, setNesting] = useState(null);
    const [key, setKey] = useState(null);
    const [isActiveInput, setIsActiveInput] = useState({ row: null, column: null });
    const [detailsModal, setDetailsModal] = useState(null)

    const handleBlur = (item, e) => {
        const { mid, id, id_group } = item
        const valuesIsEqual = e.target.value == item.value || (!Number(e.target.value) && !Number(item.value))
        if (valuesIsEqual) return;
        if ((item.forgrant == true && item.value) || item.forgrant == false) {
            setNewValue(mid, id, id_group, e);
        } else {
            setDetailsModal({...item, value: e.target.value, personnel_rating_id: 'new'});
        }

    }

    const handleFocus = (cValue, mid, id, group, index) => (e) => {
        setIsActiveInput(prev => ({
            ...prev,
            row: mid,
            column: id
        }))
        setCurrentCell({ cValue: cValue, mid: mid, id: id, id_group: group, index })

    }

    const checkRights = () => {
        return (state['Ввод индивидуальных достижений. Администратор.'] === 'Полный') || (state['Ввод индивидуальных достижений.'] === 'Полный')   
    }
    const handleChangeCell = (event) => {
        setCurrentCell(prev => ({
            ...prev,
            cValue: event.target
                ?.value || ''
        }));
    }

    const setNewValue = (mId, groupId, id_group, e) => {
        e.persist();
        setReport(mId, groupId, year, month, e.target?.value, schema, group);
        
        const filt = valueData && valueData.map((el, index) => el
            ?.mid == mId && el
                ?.id == groupId && el
                    ?.id_group == id_group && {
            index: index
        })
        if (filt[0]) {
            const _valueData = [...valueData];
            _valueData.splice(filt[0].index, 1);
            setValueData(([
                ..._valueData, {
                    mid: mId,
                    id: groupId,
                    id_group: id_group,
                    val: e
                        ?.target
                        ?.value
                }
            ]));
        } else {
            setValueData(prev => ([
                ...prev, {
                    mid: mId,
                    id: groupId,
                    id_group: id_group,
                    val: e
                        ?.target
                        ?.value
                }
            ]))
        }
    }

    const getNormolize = (el) => {
        return Math.floor(parseFloat(el).toFixed(3) * 100) / 100
    }

    const users = useMemo(() => {
        if (data && !!data.length) {
            const tmp = {}

            for (const line of data) {
                if (tmp[line.mid]) {
                    tmp[line.mid].push(line)
                } else {
                    tmp[line.mid] = [line]
                }
            }

            return [...Object.values(tmp)].sort((a, b) => a[0].lastname > b[0].lastname
                ? 1
                : -1)
        } else
            return []
    }, [data])

    const byGroups = useMemo(() => {
        if (users && !!users.length) {
            const tmp = users.map(user => {
                const tmp = {}

                for (const line of user) {
                    if (tmp[line.id_group]) {
                        tmp[line.id_group].push(line)
                    } else {
                        tmp[line.id_group] = [line]
                    }
                }

                return [...Object.values(tmp)]
            })

            return [...Object.values(tmp)]
        } else
            return []
    }, [users])

    const headers = useMemo(() => {
        if (byGroups && !!byGroups.length) {
            return byGroups[0][0].map(el => el)
        } else
            return []
    }, [byGroups])

    const handleKey = (e, key) => {
        if (key === 40 || key === 38) {
            e.preventDefault();
        }

        handleChangeCell(e);
        setKey(key);
    }

    const usersRow = users && users.map(user => user[0].mid);

    const usersColumn = useMemo(() => {
        let values = []
        if (nesting == 2 && users) {
            headers && headers.length && headers.map(header => users[0].map(group => {
                if (group.id_group === header.id) {
                    values.push(group.id);
                }
            }));

            return values;
        }

        if (!all.length) {
            headers && headers.length && headers
                .map(header => users[0].filter(group => group.id_group == header.id).map(subGroup => users[0].filter(group => group.id_group === subGroup.id).map(el => values.push(el.id))))
                .flat(2);

            return values;
        }

        if (all.length) {
            headers && headers.length && headers.map(header => users[0].filter(group => group.id_group == header.id).map(subGroup => takeObjects(byGroups[0]).filter(el => el.id_group === (subGroup.id)).map(group => takeObjects(byGroups[0]).filter(_el => _el.id_group == group.id).map(__el => values.push(users[0].filter(eel => eel.id === __el.id)[0].id)))))
            return values;
        }

    }, [users, nesting, all])

    useMemo(() => {

        switch (key) {
            case 40:
                // bottom
                if (usersRow.length - 1 > usersRow.indexOf(isActiveInput
                    ?.row)) {
                    setIsActiveInput(prev => ({
                        ...prev,
                        row: usersRow[usersRow.indexOf(isActiveInput
                            ?.row) + 1]
                    }));
                    document.getElementById(`${usersRow[usersRow.indexOf(isActiveInput
                        ?.row)]}_${isActiveInput
                            ?.column}`).blur();
                    document.getElementById(`${usersRow[usersRow.indexOf(isActiveInput
                        ?.row) + 1]}_${isActiveInput
                            ?.column}`).focus();
                }

                break
            case 38:
                // top
                if ([usersRow.indexOf(isActiveInput
                    ?.row)][0] > 0) {
                    setIsActiveInput(prev => ({
                        ...prev,
                        row: usersRow[usersRow.indexOf(isActiveInput
                            ?.row) - 1]
                    }));
                    document.getElementById(`${usersRow[usersRow.indexOf(isActiveInput
                        ?.row)]}_${isActiveInput
                            ?.column}`).blur();
                    document.getElementById(`${usersRow[usersRow.indexOf(isActiveInput
                        ?.row) - 1]}_${isActiveInput
                            ?.column}`).focus();
                }
                break
            case 37:
                // left
                if ([usersColumn.indexOf(isActiveInput
                    ?.column)][0] > 0) {
                    setIsActiveInput(prev => ({
                        ...prev,
                        column: usersColumn[usersColumn.indexOf(isActiveInput
                            ?.column) - 1]
                    }));
                    document.getElementById(`${isActiveInput
                        ?.row}_${usersColumn[usersColumn.indexOf(isActiveInput
                            ?.column)]}`).blur();
                    document.getElementById(`${isActiveInput
                        ?.row}_${usersColumn[usersColumn.indexOf(isActiveInput
                            ?.column) - 1]}`).focus();
                }
                break
            case 39:
                // right
                if (usersColumn.length - 1 > usersColumn.indexOf(isActiveInput
                    ?.column)) {
                    setIsActiveInput(prev => ({
                        ...prev,
                        column: usersColumn[usersColumn.indexOf(isActiveInput
                            ?.column) + 1]
                    }));
                    document.getElementById(`${isActiveInput
                        ?.row}_${usersColumn[usersColumn.indexOf(isActiveInput
                            ?.column)]}`).blur();
                    document.getElementById(`${isActiveInput
                        ?.row}_${usersColumn[usersColumn.indexOf(isActiveInput
                            ?.column) + 1]}`).focus();
                }
                break
            default:
        }
        setKey(null);
    }, [key])

    const isTwo = () => {
        if (!!data.length && headers.length + 1 == byGroups[0].length) {
            return 2;
        } else {
            return 1;
        }
    }

    useMemo(() => {
        if (isTwo() == 2) {
            setNesting(2);
        } else {
            setNesting(1);
        }
    }, [data])

    useMemo(() => {
        data && headers.map(header => users.map(user => {
            setAll([]);
            return (user.filter(group => group.id_group == header.id).map(subGroup => takeObjects(byGroups[0]).filter(el => el.id_group === (subGroup.id)).map(group => takeObjects(byGroups[0]).filter(_el => _el.id_group == group.id).map(__el => setAll(prev => [
                ...prev,
                __el
            ])))))
        }));
    }, [data])

    const contextMenuHandler = (data, num) => (e) => {
        e.preventDefault();
        setDetailsModal(data);
    }

    return (!!data.length
        ? <>
            <Popup
                isOpen={!!detailsModal?.personnel_rating_id && !!parseInt(detailsModal?.value)}
                onRequestClose={() => setDetailsModal(null)}
                currentCell={currentCell}
                selectedItem={detailsModal}
                data={achieveDetails}
                getAchievDetails={getAchievDetails}
                resetAchieveDetails={resetAchieveDetails}
                updateAchieveDetails={updateAchieveDetails}
                getAchieveFile={getAchieveFile}
                facultLabel={facultLabel}
                groupLabel={groupLabel}
                params={{ schema, group, year, month }}
                setNewValue={setNewValue}
                setReport={setReport}
                mId={detailsModal?.mid}
                groupId={detailsModal?.groupId}
                year={year}
                month={month}
                schema={schema}
                group={group}
            />
            <div className={styles.wrapper_tableFirstWrapper}>

                <div className={styles.tableFirstWrapper} id="top">
                    {users && users.length > 0 && <table
                        border="0"
                        cellPadding="0"
                        cellSpacing="0"
                        className={styles.tableReport}>
                        <tbody>
                            <tr className={styles.row0}>
                                <td className={styles.styleWhiteHard} colSpan={2}>&ensp;</td>
                            </tr>

                            {nesting == 2
                                ? <tr className={styles.row1}>
                                    <td className={styles.styleWhiteHardTwo} colSpan={2}>

                                        <>&ensp;В&#47;звание, Фамилия И.О.</>
                                    </td>
                                </tr>

                                : <tr className={styles.row1}>
                                    <td className={styles.styleWhiteHard2} colSpan={2}><>&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;</>
                                    </td>
                                </tr>
                            }

                            {nesting !== 2 && <tr className={styles.row2}>
                                <td
                                    className={!all.length
                                        ? styles.styleWhiteHard3
                                        : styles.styleWhiteHard3Big}
                                    colSpan={2}>
                                    <span>В&#47;звание, Фамилия И.О.</span>
                                </td>
                            </tr>
                            }
                            {users && users.length > 0 && users.map((user, index) => <tr className={styles.row3} key={`${user[0].mid}_${index}`}>
                                <td
                                    className={styles.styleWhite}
                                    style={{ background: `${user[0].forgrant == true ? '#0309b0' : ''}` }}
                                    title={`${user[0].lastname
                                        ? user[0].lastname
                                        : ''} ${user[0].firstname
                                            ? user[0].firstname
                                            : ''} ${user[0].patronymic
                                                ? user[0].patronymic
                                                : ''}`}
                                    colSpan={2}>&ensp; {`${user[0].lastname
                                        ? user[0].lastname
                                        : ''} ${user[0].firstname
                                            ? user[0]
                                                .firstname
                                                .split('')[0]
                                            : ''}.${user[0].patronymic
                                                ? user[0]
                                                    .patronymic
                                                    .split('')[0]
                                                : ''}.`}
                                </td>
                            </tr>)}

                        </tbody>
                    </table>
                    }
                </div>

                <div className={styles.wrapper_tableSecondWrapper}>
                    {headers && headers.length && headers.map((header, index) => <table
                        border="0"
                        cellPadding="0"
                        cellSpacing="0"
                        key={index}
                        className={styles.tableReport2}>
                        <tbody className={styles.bodyReport}>

                            <tr className={styles.row0}>
                                <td
                                    style={{ background: `${header.forgrant == true ? '#0309b0' : ''}` }}
                                    title={header.title}
                                    key={`${header.title}_${index}`}
                                    className={styles.styleWhiteHardTop}
                                    colSpan={users[0]
                                        .filter(user => user.id_group == header.id)
                                        .map(user => users[0].map(el => el.id == user.id_group).length)}>
                                    {/* TODO для отриосвки названия в таблице {header.alias}*/}
                                    {header.title}
                                </td>
                            </tr>
                            <tr className={styles.row0}>
                                {nesting && users[0].map((group, index) => group.id_group === header.id && <>
                                    <td
                                        title={group.title}
                                        style={{ background: `${group.forgrant == true ? '#0309b0' : ''}` }}
                                        className={styles.styleWhiteHard2Top}
                                        key={`${group.id}_${index}`}
                                        colSpan={nesting == 2
                                            ? (users[0].filter(user => user.id_group == group.id).length)
                                            : (users[0].filter(user => user.id_group == group.id).map(el => users[0].filter(_el => _el.id_group === el.id)).reduce((sum, amount) => sum + (amount
                                                ?.length
                                                ? amount
                                                    ?.length
                                                : 1), 0,))}>
                                        {group
                                            .alias
                                            .split('')
                                            .length > 50
                                            ? <p>{`${group
                                                .alias
                                                .slice(0, 50)}`}</p>
                                            : group.alias}
                                    </td> </>
                                )}
                            </tr>

                            <tr className={styles.row2}>
                                {users[0]
                                    .filter(group => group.id_group == header.id)
                                    .map(subGroup => users[0].filter(group => group.id_group === subGroup.id).map((el, index) =>
                                        <td
                                            title={el.title}
                                            style={{ background: `${el.forgrant == true ? '#0309b0' : ''}` }}
                                            className={styles.styleWhiteHard3Top}
                                            key={`${el.mid}_${index}`}
                                            colSpan={users[0]
                                                .filter(group => group.id_group == header.id)
                                                .map(subGroup => takeObjects(byGroups[0]).filter(eel => eel.id_group === (subGroup.id)).map(group => takeObjects(byGroups[0]).filter(_el => _el.id_group == el.id)))[0][0]
                                                .length}
                                        >
                                            {el
                                                .title
                                                .split('')
                                                .length >= 30
                                                ? <p title={el.title} style={{ background: `${el.forgrant == true ? '#0309b0' : ''}` }}>
                                                    {`${el
                                                        .alias
                                                        .slice(0, 30)}`}
                                                </p>
                                                : el.alias}
                                        </td>))
                                }
                            </tr>
                            <tr className={styles.row2}>
                                {users[0]
                                    .filter(group => group.id_group == header.id)
                                    .map(subGroup => takeObjects(byGroups[0]).filter(el => el.id_group === (subGroup.id)).map(group => takeObjects(byGroups[0]).filter(_el => _el.id_group == group.id).map((__el, index) => <td
                                        title={__el.title}
                                        style={{ background: `${__el.forgrant == true ? '#0309b0' : ''}` }}
                                        className={styles.styleWhiteHard4Top}
                                        colSpan='1'
                                        key={`${__el.mid}_${index}`}>
                                        {(__el
                                            .alias
                                            .split('')
                                            .length > 66)
                                            ? <p>
                                                {`${__el
                                                    .alias
                                                    .slice(0, 66)}`}
                                            </p>
                                            : __el.alias}
                                    </td>)))}
                            </tr>
                            {nesting == 2 && users && users.length > 0 && users.map(user => <tr>
                                {user.map((group, index) => group.id_group === header.id && <td
                                    className={(isActiveInput.row === group.mid && isActiveInput.column === group.id)
                                        ? styles.input_tableReport_Active
                                        : styles.row2}
                                    style={{ backgroundColor: group?.check_info ? '#6ce16c' : parseInt(group?.value) ? 'rgba(0, 255, 97, 0.34)' : 'none' }}
                                    onContextMenu={contextMenuHandler(group)}
                                    onMouseDown={handleFocus(group?.value, group.mid, group.id, group.id_group, index)}>
                                    <input
                                        disabled={!checkRights()}
                                        type="number"
                                        className={styles.input_tableReport}
                                        key={`${group
                                            ?.mid}_${index}`}
                                        defaultValue={(valueData && valueData.length > 0 && valueData.filter(group => group
                                            ?.mid == group
                                                ?.mid && group
                                                    ?.id == group
                                                ?.id && group
                                                    ?.id_group == group
                                                ?.id_group))
                                            ? valueData.filter(group => group
                                                ?.mid == group
                                                    ?.mid && group
                                                        ?.id == group
                                                    ?.id && group
                                                        ?.id_group == group
                                                    ?.id_group)
                                                ?.val
                                            : currentCell
                                                ?.mid == group
                                                    ?.mid && currentCell
                                                        ?.id == group
                                                    ?.id && currentCell
                                                        ?.id_group == group
                                                    ?.id_group
                                                ? currentCell
                                                    ?.cValue
                                                : group
                                                    ?.value > 0
                                                    ? getNormolize(group
                                                        ?.value)
                                                    : ''}
                                        onBlur={(e) => handleBlur(group, e)}
                                        onKeyDown={e => handleKey(e, e.which)}
                                        id={`${group.mid}_${group.id}`} />
                                </td>)
                                }
                            </tr>)
                            }

                            {users && users.length > 0 && users.map((user, index) => {
                                const tmp = [...user]
                                return (
                                    <tr key={`${user.mid}_${index}`}>
                                        {all.length
                                            ? user
                                                .filter(group => group.id_group == header.id)
                                                .map(subGroup => takeObjects(byGroups[0]).filter(el => el.id_group === (subGroup.id)).map(group => takeObjects(byGroups[0]).filter(_el => _el.id_group == group.id).map((__el, index) => <td
                                                    className={(isActiveInput.row === user.filter(eel => eel.id === __el.id)[0].mid && isActiveInput.column === user.filter(eel => eel.id === __el.id)[0].id)
                                                        ? styles.input_tableReport_Active
                                                        : styles.row2}
                                                    key={`${__el.mid}_${index}`}
                                                    style={{ backgroundColor: user.filter(eel => eel.id === __el.id)[0].check_info ? '#6ce16c' : parseInt(user.filter(eel => eel.id === __el.id)[0].value) ? 'rgba(0, 255, 97, 0.34)' : 'none' }}
                                                    onContextMenu={contextMenuHandler(user.filter(eel => eel.id === __el.id)[0])}
                                                    onMouseDown={handleFocus(user.filter(eel => eel.id === __el.id)[0]
                                                        ?.value, user.filter(eel => eel.id === __el.id)[0].mid, user.filter(eel => eel.id === __el.id)[0].id, user.filter(eel => eel.id === __el.id)[0].id_group, index)}>
                                                    <input
                                                        disabled={!checkRights()}
                                                        type="number"
                                                        className={styles.input_tableReport}
                                                        defaultValue={(user && user.length > 0 && user.filter(eel => eel.id === __el.id)[0].value) > 0
                                                            ? getNormolize(user.filter(eel => eel.id === __el.id)[0]
                                                                ?.value)
                                                            : currentCell
                                                                ?.mid == user.filter(eel => eel.id === __el.id)[0]
                                                                    ?.mid && currentCell
                                                                        ?.id == user.filter(eel => eel.id === __el.id)[0]
                                                                    ?.id && currentCell
                                                                        ?.id_group == user.filter(eel => eel.id === __el.id)[0]
                                                                    ?.id_group
                                                                ? currentCell
                                                                    ?.cValue
                                                                : user.filter(eel => eel.id === __el.id)[0]
                                                                    ?.value > 0
                                                                    ? user.filter(eel => eel.id === __el.id)[0]
                                                                        ?.value
                                                                    : ''}
                                                        onBlur={(e) => handleBlur(user.filter(eel => eel.id === __el.id)[0], e)}
                                                        onKeyDown={e => handleKey(e, e.which)}
                                                        id={`${user
                                                            .filter(eel => eel.id === __el.id)[0]
                                                            .mid}_${user
                                                                .filter(eel => eel.id === __el.id)[0]
                                                                .id}`} />
                                                </td>)))

                                            : user
                                                .filter(group => group.id_group === header.id)
                                                .map(subGroup => tmp.map((group, index) => group.id_group === subGroup.id && <td
                                                    key={group.id}
                                                    className={(isActiveInput.row === group.mid && isActiveInput.column === group.id)
                                                        ? styles.tdStyleActive
                                                        : styles.tdStyle}
                                                    style={{ backgroundColor: group.check_info ? '#6ce16c' : parseInt(group.value) ? 'rgba(0, 255, 97, 0.34)' : 'none' }}
                                                    onContextMenu={contextMenuHandler(group)}
                                                    onMouseDown={handleFocus(group.value, group.mid, group.id, group.id_group, index)}>
                                                    <input
                                                        disabled={!checkRights()}
                                                        type="number"
                                                        className={styles.input_tableReport}
                                                        defaultValue={(valueData && valueData.length > 0 && valueData.filter(el => el
                                                            ?.mid == group
                                                                ?.mid && el
                                                                    ?.id == group
                                                                ?.id && el
                                                                    ?.id_group == group
                                                                ?.id_group))
                                                            ? valueData.filter(el => el
                                                                ?.mid == group
                                                                    ?.mid && el
                                                                        ?.id == group
                                                                    ?.id && el
                                                                        ?.id_group == group
                                                                    ?.id_group).val
                                                            : currentCell
                                                                ?.mid == group
                                                                    ?.mid && currentCell
                                                                        ?.id == group
                                                                    ?.id && currentCell
                                                                        ?.id_group == group
                                                                    ?.id_group
                                                                ? currentCell.cValue
                                                                : group.value > 0
                                                                    ? getNormolize(group.value)
                                                                    : ''}
                                                        onBlur={(e) => handleBlur(group, e)}
                                                        onKeyDown={e => handleKey(e, e.which)}
                                                        id={`${group.mid}_${group.id}`} />
                                                </td>))
                                        }
                                    </tr>
                                )
                            })
                            }
                        </tbody>
                    </table>)}
                </div>
            </div> </>
        : <NoData text="Отсутствуют данные для выбранной групп" />)
}

export default Table